<template>
  <StoreyTemplate
    :sidebar="sidebar"
    :uuid="uuid"
    :current-storey="currentStorey"
  ></StoreyTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import StoreyTemplate from '../preview/StoreyTemplate';

export default {
  name: 'InstanceGroupPreview',
  components: {
    StoreyTemplate,
  },

  props: {
    sidebar: {
      type: Object,
      required: true,
    },
    uuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  //   uuid: {
  //     handler() {
  //       if (this.abortController) {
  //         this.abortController.abort(); // Отмена предыдущего запроса
  //       }
  //       this.abortController = new AbortController();

  //       this.init(this.abortController.signal);
  //     },
  //     immediate: true,
  //   },
  //   visibleSidebars: {
  //     handler: async function (newSidebar) {
  //       if (this.frame?.image && !this.canvasHasError) {
  //         this.handleActiveStateFromSidebars(newSidebar);
  //       }
  //     },
  //     immediate: true,
  //   },
  // },
  computed: {
    ...mapGetters(['storeys', 'visibleSidebars']),
    currentStorey() {
      return (
        this.storeys?.find((storey) => storey.id == this.sidebar.context) ??
        null
      );
    },
  },
  methods: {},
};
</script>

<style scoped></style>
